<template>
  <FormLoading :loading="getLoading" :count="4" class="padding-top-16">
    <template>
      <div class="padding-x-16 padding-bottom-16">
        <Dropdown
          :title="$lang.version_number"
          :label="$lang.version_number"
          :placeholder="$lang.version_number"
          :value="form.version"
          name="version"
          id="version"
          :vuelidateObj="$v.form.version"
          :options="versionOptions"
          :loading="versionLoading"
          :asyncSearch="getWhatsNewVersionOptions"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <EnumDropdown
          :title="$lang.change_type"
          :label="$lang.change_type"
          :placeholder="$lang.change_type"
          :value="form.changeType"
          name="changeType"
          id="changeType"
          categoryName="whats_new_change_type"
          :multiple="false"
          :vuelidateObj="$v.form.changeType"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <Input
          :title="`${$lang.task_number} (${$lang.optional})`"
          :label="$lang.task_number"
          :placeholder="$lang.task_number"
          :value="form.taskNumber"
          name="taskNumber"
          id="taskNumber"
          type="number"
          :minLength="lengthNumber11"
          :maxLength="lengthNumber11"
          :vuelidateObj="$v.form.taskNumber"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <Input
          :title="$lang.change_desc"
          :label="$lang.change_desc"
          :placeholder="$lang.change_desc"
          :value="form.description"
          name="description"
          id="description"
          type="textarea"
          :vuelidateObj="$v.form.description"
          :textareaRows="7"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
      </div>
    </template>
  </FormLoading>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  FormLoading,
  Dropdown,
  EnumDropdown,
  Input,
} from "@/components/re-design/forms";
import { required, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { getWhatsNewVersionCombo } from "@/services";
import { getOneWhatsNew } from "@/modules/profile/services";

export default {
  mixins: [inputMixin],
  components: {
    Dropdown,
    EnumDropdown,
    FormLoading,
    Input,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: [String, Number],
      default: null,
    },
  },
  validations() {
    return {
      form: {
        version: { required },
        changeType: { required },
        taskNumber: { numeric },
        description: { required },
      },
    };
  },
  data() {
    return {
      form: {
        version: null,
        changeType: null,
        taskNumber: null,
        description: null,
      },
      getLoading: false,
      versionLoading: false,
      versionOptions: [],
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.resetForm();
          this.getWhatsNewVersionOptions();
        }
      },
    },
    itemId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getWhatsNewData();
        }
      },
    },
  },
  methods: {
    pathOr,
    async getWhatsNewVersionOptions(text = null) {
      try {
        this.versionLoading = true;
        const response = await getWhatsNewVersionCombo(text);
        const { options } = response;
        this.versionOptions = [...options];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.versionLoading = false;
      }
    },
    async getWhatsNewData() {
      try {
        this.getLoading = true;
        const response = await getOneWhatsNew(this.itemId);
        const { version, changeType, taskNumber, description } = response;
        this.form.version = version;
        this.form.changeType = changeType;
        this.form.taskNumber = taskNumber;
        this.form.description = description;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.getLoading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const versionId = pathOr(null, ["id"], this.form.version);
      const changeTypeId = pathOr(null, ["id"], this.form.changeType);
      const { taskNumber, description } = this.form;
      const payload = {
        versionId,
        changeTypeId,
        taskNumber,
        description,
      };

      this.$emit("submit", payload);
    },
  },
};
</script>
